import { useState, useMemo, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import SalesForm from './salesForm';
import { toast } from 'react-toastify';
import apiServices from '../../services/service';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchSalesOrderedItemAndAppendToModule,
  singleRowAddUpdateInStore,
} from '../../redux/actions';
import { initValueSalesOrder } from '../../shared/initials';
import cancel from '../../../src/assets/img/crm_home/header/cancel.png';
import save from '../../../src/assets/img/crm_home/header/save.png';
import {
  getGridDataByModuleKey,
  getProductList,
  getSalesById,
  getSalesOrder,
  getUser,
} from '../../redux/selector';
import { validationSchemaSales } from './validationSchemaSalesOrder';
import Loader from '../../shared/component/Loader';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';

export const AddSales = () => {
  
  const userInfo = useSelector(getUser);
  if (!initValueSalesOrder.salesOwner) {
    initValueSalesOrder.salesOwner = userInfo?.user?.display_name;
    initValueSalesOrder.salesOwnerId = userInfo?.user?.userId;
  }
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [formData, setFormData] = useState(initValueSalesOrder);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const navigate = useNavigate();
  const [imagefile, setImageFile] = useState(null);
  const [imageUploadStatus, setImageUploadStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');
  const gridData = useSelector(getGridDataByModuleKey('salesOrder'));
  const salesOrderList = useSelector(getSalesOrder);
  const productList = useSelector(getProductList);

   

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const salesLocalData = useSelector((state) => {
    const salesId = location.state?.id || id;
    return getSalesById(state, salesId);
  });

  // useEffect(() => {
  //   const salesId = location.state?.id || id;
  //   if (location.pathname.includes("editSales")) {
  //     setFormData({
  //       ...salesLocalData,
  //       type: "edit",
  //       rowIndex: location.state?.rowIndex,
  //     });
  //   }

  //   if (location.pathname.includes("createSales")) {
  //     let formDataValue =
  //       location.state?.data != null ? location.state?.data : formData;
  //     let currentDate = new Date();
  //     setFormData({
  //       ...formDataValue,
  //       salesOwner:
  //         location.state?.data != null ? location.state?.data?.quoteOwner : "",
  //       orderDate: currentDate.toISOString().split("T")[0],
  //       type: "add",
  //       callBy: location.state?.data != null ? location.state?.type : "",
  //     });
  //   }

  //   if (salesOrderList && salesOrderList.length > 0 && salesId) {
  //     dispatch(
  //       fetchSalesOrderedItemAndAppendToModule({
  //         moduleName: "SaleOrder",
  //         id: id,
  //       })
  //     );
  //   }
  // }, [location, salesLocalData?.id]);

  useEffect(() => {
    const fetchSalesDetails = async () => {
      const isAddMode = location.pathname.includes('create');
      const isEditMode = location.pathname.includes('edit');
      const stateData = location.state;
      const type = isAddMode ? 'add' : 'edit';
      const initialData = stateData ?? formData;
      let updatedInvoiceFormData = { ...initialData, type };
      let updatedFormData = {
        ...updatedInvoiceFormData,
        type: type,
      };

      if (location.pathname.includes('edit') && location.state) {
        setLoading(true);
        try {
          const response = await apiServices.getSalesOrderDetailsById(location.state);

          if (response.status === 200) {
            const saleOrderDetails = response.data?.saleOrderDetails || [];

            updatedFormData = {
              ...location.state,
              saleOrderDetails,
              type: 'edit',
            };

            setFormData(updatedFormData);

            setLoading(false);
          } else {
            console.error('Failed to fetch quote details:', response);
            setLoading(false);
          }
        } catch (err) {
          setLoading(false);
          console.error('API error in getQuoteDetailsByQuoteId:', err);
        }
      } else {
        setFormData(updatedFormData);
      }
    };

    fetchSalesDetails();
  }, [location]);

  const calculateQuoteTotals = (quoteItems, adjustment = 0) => {
    const updatedWithCalcs = quoteItems.map((item, index) => {
      const quantity = Number(item.quantity) || 0;
      const listPrice = Number(item.listPrice) || 0;
      const amount = quantity * listPrice;

      let discountPercent = Number(item.discountPercent) || 0;
      let discountAmount = Number(item.discountAmount) || 0;
      if (discountAmount && !discountPercent) {
        discountPercent = (discountAmount / amount) * 100;
      } else {
        discountAmount = (amount * discountPercent) / 100;
      }

      let taxPercent = Number(item.taxPercent) || 0;
      let taxAmount = Number(item.taxAmount) || 0;
      if (taxAmount && !taxPercent) {
        taxPercent = (taxAmount / amount) * 100;
      } else {
        taxAmount = (amount * taxPercent) / 100;
      }

      const lineTotal = amount - discountAmount + taxAmount;

      return {
        ...item,
        quantity,
        listPrice,
        amount,
        discountPercent,
        discountAmount,
        taxPercent,
        taxAmount,
        lineTotal,
        lineNumber: index + 1,
      };
    });

    const subTotal = updatedWithCalcs.reduce((sum, item) => sum + (item.amount || 0), 0);
    const discountTotal = updatedWithCalcs.reduce(
      (sum, item) => sum + (item.discountAmount || 0),
      0
    );
    const taxTotal = updatedWithCalcs.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
    const grandTotal = subTotal - discountTotal + taxTotal + Number(adjustment || 0);

    return {
      saleOrderDetails: updatedWithCalcs,
      subTotal,
      discountTotal,
      taxTotal,
      grandTotal,
    };
  };

  const handleChangeForm = (e, rowIndex, changeFrom) => {
  if (changeFrom !== 'SalesOrder') {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: name === 'adjustment' ? parseFloat(value) || 0 : value,
      };

      if (name === 'adjustment') {
        const totals = calculateQuoteTotals(prev.saleOrderDetails || [], updated.adjustment);
        return { ...updated, ...totals };
      }

      return updated;
    });

    setFormEdited(true);
    return;
  }

  // Handle quoteDetails row updates
  setFormData((prev) => {
    const updatedItems = [...prev.saleOrderDetails];
    const updatedRow = { ...updatedItems[rowIndex], ...e };
    updatedItems[rowIndex] = updatedRow;

    const totals = calculateQuoteTotals(updatedItems, prev.adjustment);

    return {
      ...prev,
      saleOrderDetails: updatedItems,
      ...totals,
    };
  });

  setFormEdited(true);
};


  const handleChange = (selectedOption, name, rowIndex = null) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));
    setFormEdited(true);
    handleLookupDropDownChange(selectedOption.value, selectedOption, name, rowIndex);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name, rowIndex = null) => {
    const selectedValue = selectedOption.label;

    // Clear error for the current field
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFields = {
      contactName: (prev) => ({
        ...prev,
        contactId: selectedId,
        contactName: selectedValue,
      }),
      salesOwnerId: (prev) => ({
        ...prev,
        salesOwnerId: selectedId,
        salesOwner: selectedValue,
      }),
      accountName: (prev) => ({
        ...prev,
        accountId: selectedId,
        accountName: selectedValue,
      }),
      opportunityName: (prev) => ({
        ...prev,
        opportunityId: selectedId,
        opportunityName: selectedValue,
      }),
      status: (prev) => ({
        ...prev,
        status: selectedValue,
        statusId: selectedId,
      }),
      carrier: (prev) => ({
        ...prev,
        carrier: selectedValue,
        // carrierId: selectedId
      }),
      currency: (prev) => ({
        ...prev,
        currency: selectedValue,
        // currencyId: selectedId
      }),
      quoteName: (prev) => ({
        ...prev,
        quoteId: selectedId,
        quoteName: selectedValue,
      }),
      productId: (prev) => {
        const selectedProduct = productList.find((p) => p.id === selectedId);

        const updatedQuoteItems = [...prev.saleOrderDetails];
        const currentRow = updatedQuoteItems[rowIndex] || {};

        updatedQuoteItems[rowIndex] = {
          ...currentRow,
          productId: selectedId,
          productName: selectedValue,
          listPrice: selectedProduct?.unitPrice || 0,
        };

        return {
          ...prev,
          saleOrderDetails: updatedQuoteItems,
        };
      },
    };

    if (updatedFields[name]) {
      setFormData((prevData) => updatedFields[name](prevData));
      setFormEdited(true);
    }
  };

  const refs = {
    overview: useRef(null),
    salesOrder: useRef(null),
    attachments: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };

  const updateList = async (msg, id) => {
    setLoading(false);

    toast.success(msg, {
      position: 'top-right',
    });

    try {
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'SaleOrder',
          moduleKey: 'salesOrder',
          id: formData?.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      if (formData.from === 'view') {
        navigate(`/sales/viewSalesOrder?id=${formData.id}`);
      } else {
         navigate('/sales/salesOrder');
      }
    } catch (error) {
      console.error('Failed to fetch and update leads:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };
  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set the checkbox state as true/false
    }));
    setFormEdited(true);
  };

  useEffect(() => {
  if (!formData?.orderDate) {
    const today = new Date().toISOString().substring(0, 10); // yyyy-mm-dd
    setFormData((prev) => ({
      ...prev,
      orderDate: today,
    }));
  }
}, []);

// ✅ Function to handle checkbox toggle
const handleSameAsBillingChange = (e) => {
  const checked = e.target.checked;

  setFormData((prev) => ({
    ...prev,
    sameAsBilling: checked,
    ...(checked
      ? {
          shippingStreet: prev.billingStreet || "",
          shippingCity: prev.billingCity || "",
          shippingState: prev.billingState || "",
          shippingCountry: prev.billingCountry || "",
          shippingCode: prev.billingCode || "",
        }
      : {
          shippingStreet: "",
          shippingCity: "",
          shippingState: "",
          shippingCountry: "",
          shippingCode: "",
        }),
  }));
};

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const sanitizedData = {
        ...formData,
      };
      await validationSchemaSales.validate(sanitizedData, {
        abortEarly: false,
      });
      handleFormSubmit(sanitizedData);
    } catch (error) {
      setLoading(false);
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      const errorFields = Object.keys(fieldErrors);
      if (errorFields.length > 0) {
        const firstErrorKey = errorFields[0];
        const errorRef = refs[firstErrorKey];
        if (errorRef?.current) {
          errorRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
          errorRef.current.focus();
        }
      } else {
        // Submit the form!
      }

      console.error('Validation Error:', fieldErrors);
    }
  };

  const handleFormSubmit = (formData) => {
    if (formData?.type === 'add') {
      apiServices
        .createSalesOrder(formData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            updateList('Sales Order created successfully!', id);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      apiServices
        .updateSalesOrder(formData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Sales Order updated successfully!');
            updateSalesOrderDetails(formData?.saleOrderDetails);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    }
  };

  const handleCloseAddForm = () => {
    // if (formData.from === 'view' && formData.callBy == '') {
    //   navigate(
    //     `/sales/viewSalesOrder?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`
    //   );
    // } else if (formData.from === 'view' && formData.callBy == 'QuoteView') {
    //   navigate(`/quoteAI/regularQuoteView?id=${formData.id}`);
    // } else {
    //   navigate('/sales/salesOrder');
    // }
    navigate(-1);
  };

  const handleAddRow = () => {
    setFormData((prev) => ({
      ...prev,
      saleOrderDetails: [
        ...(prev.saleOrderDetails || []),
        {
          productId: '',
          description: '',
          discountPercent: 0,
          discountAmount: 0,
          taxPercent: 0,
          taxAmount: 0,
          lineTotal: 0,
          currency:"",
          quantity: 0,
          id: '',
          salesOrderId: formData?.id,
        },
      ],
    }));
  };

  const handleDeleteRow = (index, id) => {
    getSalesOrderDetailsDelete(id, index);
  };

 const getSalesOrderDetailsDelete = (id, index) => {
  if (id) {
    // If the row has an ID, call the delete API
    let data = { id: [id] };

    apiServices
      .getSalesOrderDetailsDeleteById(data)
      .then((response) => {
        if (response.status === 200) {
          deleteRowByIndex(index);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error('An unexpected error occurred.', {
          position: 'top-right',
        });
        setLoading(false);
      });
  } else {
    // No ID — directly delete the row
    deleteRowByIndex(index);
  }
};

// Extract row deletion logic to reuse it
const deleteRowByIndex = (index) => {
  setFormData((prev) => {
    if (prev.saleOrderDetails.length <= 1) {
      toast.warn('At least one row is required.', {
        position: 'top-right',
      });
      return prev;
    }

    const updatedItems = prev.saleOrderDetails.filter((_, i) => i !== index);
    return {
      ...prev,
      saleOrderDetails: updatedItems.map((item, idx) => ({
        ...item,
        lineNumber: idx + 1,
      })),
    };
  });
};



  const handleAddPriceSheetToItems = (selectedProducts) => {
    setFormData((prev) => {
      const updatedQuoteItems = (prev.saleOrderDetails || []).map((item) => {
        const matchedProduct = selectedProducts.find((p) => p.productId === item.productId);

        if (matchedProduct) {
          return {
            ...item,
            listPrice: matchedProduct.listPrice,
          };
        }

        return item;
      });

      const totals = calculateQuoteTotals(updatedQuoteItems, prev.adjustment);

      return {
        ...prev,
        saleOrderDetails: updatedQuoteItems,
        ...totals,
      };
    });

    setLoading(false);
  };

  const updateSalesOrderDetails = (updatedRowData) => {
    if (updatedRowData) {
      let data = {
        saleOrderDetailList: updatedRowData,
      };
      apiServices
        .updateSalesOrderDetailsById(data)
        .then((response) => {
          if (response.status === 200) {
            updateList('Sales Ordered Items updated successfully!');
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
      // });
    }
  };
  return (
    <>
      {loading && <Loader />}
      <div className="inner-page" style={containerStyle}>
        <div id="crm-sales-page">
          <div className="viewHeader viewshadow">
            <HeaderProfileBlock
              localData={formData}
              moduleName={'Sales Order'}
              uploadFile={handleUploadImage}
            />
            <div className="dsk">
              <div className="rightAction">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  data-bs-dismiss="modal"
                  onClick={handleCloseAddForm}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleSubmit(formData);
                  }}
                  disabled={loading || (formData?.type === 'edit' && !formEdited)}
                >
                  {loading && (
                    <>
                      {' '}
                      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                    </>
                  )}
                  {loading ? 'Loading...' : 'Save'}
                </button>
              </div>
            </div>
            <div className="mob">
              <div className="rightAction">
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  data-bs-dismiss="modal"
                  onClick={handleCloseAddForm}
                >
                  <img src={cancel} alt="Cancel" style={{ width: '12px', height: 'auto' }} />
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handleSubmit(formData);
                  }}
                  disabled={loading || (formData?.type === 'edit' && !formEdited)}
                >
                  {loading ? (
                    <>
                      {' '}
                      <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                    </>
                  ) : (
                    <img src={save} alt="Save" style={{ width: '13px', height: 'auto' }} />
                  )}
                </button>
              </div>
            </div>
          </div>
          <SalesForm
            handleChangeForm={handleChangeForm}
            handleChange={handleChange}
            formData={formData}
            handleSubmit={handleSubmit}
            errormsg={errormsg}
            handleAddRow={handleAddRow}
            handleDeleteRow={handleDeleteRow}
            handleChangeCheckBox={handleChangeCheckbox}
            handleAddPriceSheetToItems={handleAddPriceSheetToItems}
            handleSameAsBillingChange={handleSameAsBillingChange}
          />
        </div>
      </div>
    </>
  );
};

export default AddSales;
